import React, {useCallback} from 'react'
import {NumericFormat} from "react-number-format"
import PropTypes from "prop-types"

const RegularNumberFormatter = ({inputRef, onChange, name, propagateEventsOnly, ...others}) => {
    const onValueChange = useCallback(
        (values, sourceInfo) => {
            const shouldCallOnChange = (sourceInfo?.source === "event") && !propagateEventsOnly
            if (shouldCallOnChange) {
                onChange({
                    target: {
                        name,
                        value: values.formattedValue,
                    },
                })
            }
        },
        [propagateEventsOnly, onChange, name],
    )

    return <NumericFormat
        {...others}
        getInputRef={inputRef}
        onValueChange={onValueChange}
        thousandSeparator={"."}
        decimalSeparator={","}
    />
}

RegularNumberFormatter.propTypes = {
    propagateEventsOnly: PropTypes.bool,
    inputRef: PropTypes.any,
    onChange: PropTypes.any,
    name: PropTypes.any,
}

RegularNumberFormatter.defaultProps = {
    propagateEventsOnly: false,
    inputRef: null,
    onChange: null,
    name: null,
}

export default RegularNumberFormatter
